import { FETCH_LICENSING_ACTIONS_PROVIDED } from "./LicensingActionsTypes";

export const fetchLicensingActionsProvided = (licensingActions) => {
    return {
      type: FETCH_LICENSING_ACTIONS_PROVIDED,
      payload: licensingActions,
    };
  };